<template>
  <div style="height: 100vh">
    <v-dialog v-model="isGetStarted" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <template v-if="isGetStarted && $store.state.isLoggedIn">
          <div id="get-started">
            <get-started
              v-model="pageid"
              channel="line"
              @close="isGetStarted = false"
            ></get-started>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import GetStarted from '@/components/view/getstarted/GetStarted'
import crypto from 'crypto-js'

export default {
  components: {
    GetStarted
  },
  data() {
    return {
      isGetStarted: false,
      pageid: null
    }
  },
  async mounted() {
    var state = []
    this.$store.dispatch('loading')
    if (this.$route.query.state) {
      let bytes = crypto.AES.decrypt(this.$route.query.state.replaceAll(' ', '+'), 'awesomezwizai')
      let decryptedData = bytes.toString(crypto.enc.Utf8)
      let query = decryptedData.split(',')
      try {
        state = query
          .map((el) => el.split('='))
          .reduce((prev, curr) => {
            prev[curr[0]] = curr[1]
            return prev
          }, {})
      } catch (error) {}
    }
    if (this.$route.query.error) {
      this.$store.dispatch('loading')
      await this.$swal.fire({
        title: this.$t('Something went wrong'),
        text: this.$route.query.error,
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        reverseButtons: true
      })
      window.location = `/${state && state.lang ? state.lang : 'th'}/nigol`
    } else if (this.$route.query && this.$route.query.code && state && state.userid) {
      try {
        let line_redirect_url = `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? ':' + window.location.port : ''
        }/connectline`

        let data = {
          code: this.$route.query.code,
          redirect_url: line_redirect_url
        }

        if (state.pageid) {
          data.pageid = state.pageid
        }

        let response = await this.post('line-modular/subscribe', data, {}, false)

        if (response.success) {
          var utm = ''
          if (state && state.utm_source) {
            utm = state.utm_source
          }
          var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''

          // this.$ga.event('event', prefix + 'login_line', utm)

          this.$router.push({
            path: '/' + (state && state.lang ? state.lang : 'th') + '/allbots',
            query: state
          })
        } else {
          throw new Error('Connect line unsuccessfully')
        }
      } catch (error) {
        console.error(error)
        await this.$swal.fire({
          title: this.$t('Something went wrong'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
        window.location = `/${state && state.lang ? state.lang : 'th'}/nigol`
      }
    }

    this.$store.dispatch('loading')
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/login/ConnectLine.vue